/* eslint-disable react/prop-types */
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import PlansSelect from './PlansSelect'
import UsageTypeSelect from './UsageTypeSelect'

function EditFeatureDialog({
  open,
  featureName,
  description,
  usageType,
  plans,
  onDescriptionChange,
  onUsageTypeChange,
  onPlansChange,
  onCancel,
  onSubmit,
}) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Editar feature: {featureName}</DialogTitle>
      <DialogContent>
        <TextField
          label="Descrição"
          value={description}
          onChange={(event) => onDescriptionChange(event.target.value)}
          fullWidth
          multiline
          minRows={2}
          margin="normal"
        />
        <PlansSelect labelId="edit-plans-label" value={plans} onChange={onPlansChange} />
        <UsageTypeSelect labelId="edit-usage-type-label" value={usageType} onChange={onUsageTypeChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button variant="contained" onClick={onSubmit}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditFeatureDialog
